import { render, staticRenderFns } from "./ModulosModalEdicion.vue?vue&type=template&id=2762761a&scoped=true&"
import script from "./ModulosModalEdicion.vue?vue&type=script&lang=ts&"
export * from "./ModulosModalEdicion.vue?vue&type=script&lang=ts&"
import style0 from "./ModulosModalEdicion.vue?vue&type=style&index=0&id=2762761a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2762761a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2762761a', component.options)
    } else {
      api.reload('2762761a', component.options)
    }
    module.hot.accept("./ModulosModalEdicion.vue?vue&type=template&id=2762761a&scoped=true&", function () {
      api.rerender('2762761a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mantenedores/ModulosModalEdicion.vue"
export default component.exports